import { Wrapper, Article, Header, Content, Footer } from './styles'

export default function DeliveryTerms() {
  return (
    <Wrapper>
      <Article>
        <Header>
          <img src="/logo.svg" alt="MeniuDigital" className="logo" />
          <h1>Politica de livrare</h1>
          <div className="subtitle">Actualizat: 13 Noiembrie 2024</div>
        </Header>

        <Content>
          <h2>Servicii digitale - Fără livrare fizică</h2>
          <p>
            MeniuDigital este o platformă de digitalizare a meniurilor pentru restaurante, hoteluri, cafenele și baruri.
          </p>

          <div className="highlight">
            <strong>Nu oferim produse fizice și nu există nicio livrare materială.</strong>
            <br />
            <br />
            Serviciile noastre constau exclusiv în furnizarea de soluții digitale pentru gestionarea și afișarea meniurilor
            online, accesibile prin intermediul platformei web.
          </div>

          <h2>Livrare instantanee</h2>
          <p>Toate serviciile MeniuDigital sunt disponibile instant după finalizarea procesului de înregistrare și plată:</p>

          <ul>
            <li>
              <strong>Acces imediat</strong> - Veți primi acces la platforma de administrare imediat după crearea contului
            </li>
            <li>
              <strong>Activare instantanee</strong> - Funcționalitățile sunt activate automat după efectuarea plății
            </li>
            <li>
              <strong>Fără timpi de așteptare</strong> - Nu există perioadă de livrare sau instalare
            </li>
            <li>
              <strong>Disponibilitate 24/7</strong> - Accesul la platformă este disponibil oricând, de pe orice dispozitiv
            </li>
          </ul>

          <h2>Cum funcționează</h2>

          <h3>1. Înregistrare</h3>
          <p>
            Creați-vă contul gratuit pe{' '}
            <a href="https://admin.meniudigital.ro" target="_blank" rel="noopener noreferrer">
              https://admin.meniudigital.ro
            </a>
          </p>

          <h3>2. Acces imediat la platformă</h3>
          <p>
            Primiți instant acces la interfața de administrare unde puteți începe să vă creați meniul digital
          </p>

          <h3>3. Plată pentru servicii premium</h3>
          <p>
            După depășirea limitei gratuite (30 de produse), puteți achita abonamentul direct online prin card bancar (Visa
            sau MasterCard) folosind platforma securizată{' '}
            <a href="https://netopia-payments.com/" target="_blank" rel="noopener noreferrer">
              Netopia Payments
            </a>
          </p>

          <h3>4. Activare automată</h3>
          <p>Toate funcționalitățile premium sunt activate automat imediat ce plata este confirmată</p>

          <h2>Facturare</h2>
          <p>
            Factura fiscală va fi emisă automat pe datele de facturare furnizate în momentul înregistrării sau al efectuării
            plății.
          </p>

          <div className="info-box">
            <p>
              <strong>Modificare date de facturare:</strong>
              <br />
              Pentru modificarea datelor de facturare, vă rugăm să ne contactați la{' '}
              <a href="mailto:contact@meniudigital.ro">contact@meniudigital.ro</a>
            </p>
          </div>

          <h2>Suport tehnic</h2>
          <p>Pentru orice întrebări sau asistență tehnică, suntem disponibili:</p>

          <div className="info-box">
            <strong>TOUCHFREEMENU SRL</strong>
            <br />
            Strada Șugău nr. 46A
            <br />
            Sighetu Marmației, Maramureș 435500
            <br />
            România
            <br />
            <br />
            <strong>Email:</strong> <a href="mailto:contact@meniudigital.ro">contact@meniudigital.ro</a>
            <br />
            <br />
            C.U.I.: 44695880
            <br />
            Reg.Com.: J24/1306/05.08.2021
          </div>

          <p>
            Pentru mai multe detalii despre serviciile noastre, vizitați{' '}
            <a href="https://www.meniudigital.ro" target="_blank" rel="noopener noreferrer">
              www.meniudigital.ro
            </a>{' '}
            sau consultați <a href="/terms-and-conditions">Termenii și condițiile</a>.
          </p>
        </Content>

        <Footer>
          <h3>Contact</h3>
          <div className="company-info">
            <strong>TOUCHFREEMENU SRL</strong>
            Strada Șugău nr. 46A
            <br />
            Sighetu Marmației, Maramureș 435500
            <br />
            România
            <br />
            <br />
            <strong>E-mail:</strong> <a href="mailto:contact@meniudigital.ro">contact@meniudigital.ro</a>
            <br />
            <br />
            C.U.I.: 44695880
            <br />
            Reg.Com.: J24/1306/05.08.2021
          </div>

          <div className="links">
            <a href="/terms-and-conditions">Termeni și condiții</a>
            <a href="/cancellation-policy">Politica de anulare</a>
            <a href="/privacy-policy">Confidențialitate</a>
          </div>
        </Footer>
      </Article>
    </Wrapper>
  )
}
